import PropTypes from 'prop-types';
import { createComponent } from '../core/create-component.js';
var propTypes = {
  /**
  * Visual style of StepIndicatorStepValue
  * Available options: "standard", "error"
  */
  skin: PropTypes.oneOf(['standard', 'error'])
};
var StepIndicatorStepValue = createComponent({
  displayName: 'StepIndicatorStepValue',
  root: 'span',
  propTypes: propTypes,
  propConfig: {
    classNames: function classNames(props) {
      var classNameSet = new Set(['swan-step-value']);
      var _props$skin = props.skin,
          skin = _props$skin === void 0 ? 'standard' : _props$skin;
      if (skin != 'standard') classNameSet.add("swan-step-value-skin-".concat(skin));
      return classNameSet;
    }
  }
});
StepIndicatorStepValue.defaultProps = {
  skin: 'standard'
};
export { StepIndicatorStepValue };